import React, { useState, useMemo } from 'react';
import { FiBriefcase, FiShoppingCart, FiUser } from 'react-icons/fi';
import Table from '../common/Table/Table';
import EditButton from '../common/ActionButton/EditButton';
import AddToTodoButton from '../common/ActionButton/AddToTodoButton';
import WhatsAppButton from '../common/ActionButton/WhatsAppButton';
import MailButton from '../common/ActionButton/MailButton';
import MarkTypeButton from '../common/ActionButton/MarkTypeButton';
import DeleteButton from '../common/ActionButton/DeleteButton';
import { API_BASE } from '../../config';
import {deleteEntity} from '../../utlis/deleteEntity'
import '../../style/PageTable.css'; 
import { sortArrayByKey } from '../../utlis/sortingUtils';

const ContactTable = ({
  contacts,
  onContactClick,
  handleRowClick,
  onEditClick,
  refreshContacts,
  addToTodo
}) => {

  const deleteContact = async (contactId, e) => {
    await deleteEntity({
      entityType: 'contacts',
      entityId: contactId,
      event: e,
      onDeleted: refreshContacts
    });
  };

  const markContactType = async (contactId, type, e) => {
    e.stopPropagation();
    try {
      const response = await fetch(`${API_BASE}/api/contacts/${contactId}/mark-as-${type}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `Failed to mark as ${type}`);
      }

      const data = await response.json();
      console.log(`Marked as ${type}:`, data);
      refreshContacts();
    } catch (error) {
      console.error('Error:', error);
      alert(error.message || `Failed to mark as ${type}`);
    }
  };

  const [sortConfig, setSortConfig] = useState({ key: '', direction: 'descending' });

  const handleSort = (key) => {
    let direction = 'descending';
    if (sortConfig.key === key && sortConfig.direction === 'descending') {
      direction = 'ascending';
    }
    setSortConfig({ key, direction });
  };

  const sortedContacts = useMemo(() => {
    return sortArrayByKey(contacts, sortConfig.key, sortConfig.direction);
  }, [contacts, sortConfig]);

  const columns = [
    { header: 'Name', key: 'name' },
    { header: 'Email', key: 'email' },
    { header: 'Phone', key: 'phone' },
    { header: 'Company', key: 'company_name' },
    { header: 'Company Industry', key: 'company_industry' },
    { header: 'Type', key: 'contact_type' },
    { header: 'Actions', className: 'actions-header' }
  ];

  const markTypeButtonsConfig = [
    {
      type: 'manufacturer',
      className: 'manufacturer-btn',
      title: 'Mark as Manufacturer',
      Icon: FiBriefcase
    },
    {
      type: 'buyer',
      className: 'buyer-btn',
      title: 'Mark as Buyer',
      Icon: FiShoppingCart
    },
    {
      type: 'contractor',
      className: 'contractor-btn',
      title: 'Mark as Contractor',
      Icon: FiUser
    }
  ];

  const renderRow = (contact) => (
    <>
      <td>{contact.name}</td>
      <td>{contact.email || '-'}</td>
      <td>{contact.phone || '-'}</td>
      <td>{contact.company_name || '-'}</td>
      <td>{contact.company_industry || '-'}</td>
      <td>
        {contact.contact_type === 'manufacturer' && (
          <span className="badge manufacturer">Manufacturer</span>
        )}
        {contact.contact_type === 'buyer' && (
          <span className="badge buyer">Buyer</span>
        )}
        {contact.contact_type === 'contractor' && (
          <span className="badge contractor">Contractor</span>
        )}
        {!contact.contact_type && '-'}
      </td>
      <td className="actions-cell">
        <div className="action-buttons">
          <EditButton
            onClick={(e) => {
              e.stopPropagation();
              onEditClick(contact.id);
            }}
            className="lead-edit-btn"
            title="Edit"
          />
          {contact.phone && (
            <WhatsAppButton 
              className="whatsapp-btn" 
              title="Send WhatsApp message" 
              phone={contact.phone} />
          )}
          {contact.email && (
            <MailButton 
              className="mail-btn" 
              title="Send Email" 
              email={contact.email} />
          )}
          <DeleteButton
            title="Delete"
            className="delete-btn"
            onClick={(e) => deleteContact(contact.id, e)}
          />
          <AddToTodoButton
            title="Add to Todo"
            onClick={() => addToTodo(contact)}
            className="todo-btn"
          />
          {markTypeButtonsConfig.map(({ type, className, title, Icon }) => (
            <MarkTypeButton
              key={type}
              contactId={contact.id}
              type={type}
              className={className}
              title={title}
              Icon={Icon}
              onMark={markContactType}
            />
          ))}
        </div>
      </td>
    </>
  );

  return (
    <Table
      columns={columns}
      data={sortedContacts}
      renderRow={renderRow}
      className="page-table table-container"
      onRowClick={(contact) => onContactClick(contact.id)}
      // onRowClick={handleRowClick} 
      onSort={handleSort}
      sortConfig={sortConfig}
    />
  );
};

export default ContactTable;
